import React from "react";

export function ProductHeader(props:any) {
    var selected_list_class = (props.blockType == 'list-type') ? 'display_type selected--item' : 'display_type';
    var selected_block_class = (props.blockType == 'block-type') ? 'display_type selected--item' : 'display_type';

    return (
        <div>
            <div className="sorting_wrapper_content">
                <div className="product_display_type">
                    <div onClick={props.blockHandler} className={selected_block_class} data-list="display_type" data-display-type="block-type">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                             strokeLinejoin="round" className="feather feather-grid">
                            <rect x="3" y="3" width="7" height="7"></rect>
                            <rect x="14" y="3" width="7" height="7"></rect>
                            <rect x="14" y="14" width="7" height="7"></rect>
                            <rect x="3" y="14" width="7" height="7"></rect>
                        </svg>
                    </div>
                    <div onClick={props.blockHandler} className={selected_list_class} data-list="display_type" data-display-type="list-type">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                             strokeLinejoin="round" className="feather feather-list">
                            <line x1="8" y1="6" x2="21" y2="6"></line>
                            <line x1="8" y1="12" x2="21" y2="12"></line>
                            <line x1="8" y1="18" x2="21" y2="18"></line>
                            <line x1="3" y1="6" x2="3.01" y2="6"></line>
                            <line x1="3" y1="12" x2="3.01" y2="12"></line>
                            <line x1="3" y1="18" x2="3.01" y2="18"></line>
                        </svg>
                    </div>
                </div>
                <div className="product_flex_section">

                </div>
            </div>
        </div>
    )
}